/**
 * Unauthenticated renewal form JS
 */

import $ from 'jquery';

function scrollTo(id) {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(id).offset().top - 50
    },
    500
  );
}

function renderFormError(message) {
  const alert = `<div class="alert alert-danger alert-dismissible" role="alert">
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
  ${message}
  </div>`;
  return alert;
}

$('#wl_renew_registration').submit(function(event) {
  event.preventDefault();
  $('#submit').prop('disabled', true);

  let formData = {
    firstname: $('#firstname').val(),
    lastname: $('#lastname').val(),
    email: $('#email').val(),
    confirmEmail: $('#confirmEmail').val(),
    cardtype: $('#cardtype').val(),
    accountNumber: $('#accountNumber').val(),
    expirationMonth: $('#expirationMonth').val(),
    expirationYear: $('#expirationYear').val(),
    CVV: $('#CVV').val(),
    wl_renew_registration_nonce: $('#wl_renew_registration_nonce').val(),
    recaptcha: grecaptcha.getResponse()
  };

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=wl_renew_registration',
    data: formData,
    dataType: 'json'
  })
    .done(function(data) {
      window.location.replace('/renew-your-membership/confirmation/');
    })
    .fail(function(xhr, status, error) {
      const errorResponse = xhr.responseJSON.data;
      grecaptcha.reset();

      if (errorResponse.first_name) {
        $('#firstname-field').addClass('has-error');
        $('#firstname-error').text(errorResponse.first_name);
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('#firstname-field').offset().top
          },
          500
        );
      }

      if (errorResponse.last_name) {
        $('#lastname-field').addClass('has-error');
        $('#lastname-error').text(errorResponse.last_name);
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('#lastname-field').offset().top
          },
          500
        );
      }

      if (errorResponse.email) {
        $('#email-field').addClass('has-error');
        $('#email-error').text(errorResponse.email);
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('#email-field').offset().top
          },
          500
        );
      }

      if (errorResponse.confirmEmail) {
        $('#confirm-email-field').addClass('has-error');
        $('#confirmEmail-error').text(errorResponse.confirmEmail);
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('#confirm-email-field').offset().top
          },
          500
        );
      }

      if (errorResponse.email_mismatch) {
        $('#email-field, #confirm-email-field').addClass('has-error');
        $('#email-error').text(errorResponse.email_mismatch);
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('#email-field').offset().top
          },
          500
        );
      }

      if (errorResponse.gateway) {
        $('#form-errors').html(renderFormError(errorResponse.gateway));
        scrollTo('#form-errors');
      }

      if (errorResponse.user) {
        $('#form-errors').html(renderFormError('This email address is not associated to a BAFFC membership. Please use a registered email address instead or <a href="/membership/registration/">click here to become a member</a>.'));
        scrollTo('#form-errors');
      }

      if (errorResponse.credit_card_number) {
        $('#accountNumber-field').addClass('has-error');
        $('#accountNumber-error').text(errorResponse.credit_card_number);
      }

      if (errorResponse.expiration_date) {
        $('#expirationDate-field').addClass('has-error');
        $('#expirationDate-error').text(errorResponse.expiration_date);
      }

      if (errorResponse.cvv) {
        $('#CVV-field').addClass('has-error');
        $('#CVV-error').text(errorResponse.cvv);
      }

      if (errorResponse.recaptcha) {
        $('#form-errors').html(renderFormError('Please Check ReCaptcha'));
        scrollTo('#form-errors');  
      }

      $('#submit').prop('disabled', false);
    });
});

const fields = [
  '#firstname',
  '#lastname',
  '#email',
  '#confirmEmail',
  '#accountNumber',
  '#CVV'
];

fields.forEach(field => {
  $(field).blur(function() {
    $(`${field}-field`).removeClass('has-error');
    $(`${field}-error`).text('');
  });
});

$('#expirationMonth, #expirationYear').blur(function() {
  $('#expirationDate-field').removeClass('has-error');
  $('#expirationDate-error').text('');
});



// WEBPACK FOOTER //
// ./assets/js/registration-renewal.js